import * as React from 'react';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';

import { BuilderChatButtonContainer } from '../BuilderChatButton';
import { useSelector } from 'react-redux';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { ConsultantChatButtonContainer } from '../ConsultantChatButtonContainer';

interface IMessageButtonContainerProps {
  asIcon?: boolean;
  buttonSize?: TButtonSize;
  buttonTheme?: TButtonTheme;
  placeType: string;
  isHeaderButton?: boolean;
}

/**
 * Развилка для кнопок, открывающих разные виды чатов.
 */
export const MessageButtonContainer: React.FC<IMessageButtonContainerProps> = props => {
  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);

  if (!isBuilderChatEnabled) {
    return <ConsultantChatButtonContainer {...props} />;
  }

  return <BuilderChatButtonContainer {...props} />;
};
